import React, { Component } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// The plugin PHP, via the wp_localize_script function, should have added a tag to the index.html of the form: 
// <script id="leadlazarus-js-extra">
//    var LeadLazarusParams = {"leadlazarus_api_data":[ ...API DATA HERE... ]};
// </script>
// We will now parse the API_KEY and then remove the script tag before the
// page is rendered.
// This is the only way I could find to reliably pass data from the PHP plugin code into React javascript.
// I worry that this data passing functionality is going to be dependent on the PHP version used on the server.
// PHP is the Forest Gump of programming languages: It gets everywhere, but it's fucking retarded.
var leadlazarus_api_data = "INVALID_LEAD_LAZARUS_PLUGIN_DATA";
const LeadLazarusParams = document.getElementById('leadlazarus-js-extra');

console.log("'LeadLazarusParams': ", LeadLazarusParams);

if(LeadLazarusParams != null)
{
  const found = LeadLazarusParams.innerText.indexOf("leadlazarus_api_key");
  if(found > -1)
  {
    let json_text = LeadLazarusParams.innerText.substring(found-2);
    json_text = json_text.replaceAll(";", "");
    json_text = json_text.replaceAll("\\", "");
    json_text = json_text.replaceAll("/", "");
    json_text = json_text.replaceAll("[", "");
    json_text = json_text.replaceAll("]", "");
    json_text = json_text.replaceAll("!", "");
    json_text = json_text.replaceAll("CDATA", "");
    json_text = json_text.replaceAll("<", "");
    json_text = json_text.replaceAll(">", "");
    json_text = json_text.replaceAll("*", "");
    leadlazarus_api_data = JSON.parse(json_text);
    console.log("'lead_lazarus_api_key': ", leadlazarus_api_data.leadlazarus_api_key);
    // console.log("Lead Lazaraus plugin data: ", leadlazarus_api_data);
    LeadLazarusParams.remove();
  }
  else
  {
    console.log("LeadLazarusParams NOT FOUND!!!");
  }
}

const root = ReactDOM.createRoot(document.getElementById('leadlazarus-react'));
root.render(
  <React.StrictMode>
    <App leadlazarus_api_data={leadlazarus_api_data}/>
  </React.StrictMode>
);

